import { Box, Modal } from "@mui/material";
import { useState } from "react";
import ProjectContent from "../Project/ProjectContent";
import { modalStyle } from "../../styles/globalStyles";
import Image from "next/legacy/image";
import ProjectCardContent from "../Project/ProjectCardContent";

export default function ProfileProjectCard({ project, prToOpen, isFeedback }) {
  const [openReadOnly, setOpenReadOnly] = useState(project.id === prToOpen);
  const handleProjectCardOpen = () => {
    const current = new URL(window.location);
    current.searchParams.append("project", project.id);
    window.history.replaceState("", "", current);
    setOpenReadOnly(true);
  };
  const handleProjectCardClose = () => {
    const current = new URL(window.location);
    current.searchParams.delete("project");
    window.history.replaceState("", "", current);
    setOpenReadOnly(false);
  };
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
          cursor: "pointer",
          borderColor: "primary.main",
          mx: "auto",
          position: "relative",
        }}
        borderRadius={3}
        onClick={() => handleProjectCardOpen()}
        className="card-hover"
      >
        <Image
          alt={project?.title}
          src={
            (project?.images && project?.images[0]) ??
            "/assets/project_placeholder.svg"
          }
          sizes="(min-width: 100vw) 100vw,
                 100vw"
          layout="fill"
          objectFit="cover"
          quality={5}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            height: "100%",
            width: "100%",
            position: "absolute",
            zIndex: 2,
            transition: "background 0.5s ease",
          }}
        >
          <ProjectCardContent
            project={project}
            onOpen={() => setOpenReadOnly(true)}
            forProfile
          />
        </Box>
      </Box>
      <Modal open={openReadOnly} onClose={() => handleProjectCardClose()}>
        <Box className="bg-surface" sx={{ ...modalStyle }}>
          <ProjectContent
            project={project}
            isFeedback={isFeedback}
            close={() => handleProjectCardClose()}
          />
        </Box>
      </Modal>
    </Box>
  );
}
